'use strict';

MapsService.$inject = [
  '$document',
  '$window',
  'FirebaseConnectionService',
  'ApiKeysDomain',
];

export function MapsService(
  $document,
  $window,
  FirebaseConnectionService,
  ApiKeysDomain,
) {
  const mapLoadedDeferred = Promise.defer();
  let mapApi;
  let scriptTag;

  this.init = init;
  this.mapLoaded = mapLoaded;
  this.getMaps = getMaps;

  if ($window.MarkerClusterer) { // override the image location to local values
    $window.MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../img/m';
  }

  function init() {
    $window.onMapsApiLoaded = function () {
      mapApi = $window.google.maps;
      mapLoadedDeferred.resolve(mapApi);
    };

    _loadMapsApi();
    $document[0].addEventListener('online', _loadMapsApi, false);
    $document[0].addEventListener('resume', _loadMapsApi, false);
  }

  function mapLoaded() {
    return mapLoadedDeferred.promise;
  }

  function getMaps() {
    return mapApi;
  }

  function _loadMapsApi() {
    if (!FirebaseConnectionService.online || scriptTag) return;
    ApiKeysDomain.$getKeyChain().then(_createScriptTag);
  }

  function _createScriptTag(keyChain) {
    if (keyChain.googleMaps) {
      scriptTag = $document[0].createElement('script');
      scriptTag.src = `https://maps.googleapis.com/maps/api/js?key=${keyChain.googleMaps}&callback=onMapsApiLoaded`;
      $document[0].head.appendChild(scriptTag);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/maps-api/MapsService.js